import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "services/principal/customFetchBase";

export const motivosCancelacionApi = createApi({
  reducerPath: "motivosCancelacionApi",
  baseQuery: customFetchBase,
  tagTypes: ["MotivosCancelacion"],
  endpoints: (builder) => ({
    getMotivosCancelacion: builder.query({
      query: () => ({
        url: "/v1/api/motivoscancelacion/",
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "MotivosCancelacion",
                id,
              })),
              { type: "MotivosCancelacion", id: "LIST" },
            ]
          : [{ type: "MotivosCancelacion", id: "LIST" }],
    }),
    getMotivoCancelacion: builder.query({
      query: (id) => ({
        url: `/v1/api/motivoscancelacion/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "MotivosCancelacion", id }],
    }),
  }),
});

export const {
  useGetMotivosCancelacionQuery,
  useGetMotivoCancelacionQuery,
} = motivosCancelacionApi;
